import { api, Game, GameVersion, VersionChannel } from "../api/client";
import { useEffect, useState } from "react";

export type { VersionChannel };

export default function useGameAndVersion(
  game?: string,
  version?: string | null,
  majorVersion?: number,
  channel?: VersionChannel
) {
  const [gameDoc, setGameDoc] = useState<Game | undefined>(undefined);
  const [gameVersion, setGameVersionDoc] = useState<GameVersion | undefined>(
    undefined
  );
  const [gameLoading, setGameLoading] = useState(true);
  const [gameError, setGameError] = useState<string | null>(null);

  useEffect(() => {
    if (!game) {
      setGameError("No game specified");
      setGameLoading(false);
      return;
    }

    setGameLoading(true);

    const loadGame = async () => {
      try {
        // Single server call that handles version resolution server-side
        const { game: gd, version: vs } = await api.getGameWithVersion(game, {
          version: version ?? undefined,
          majorVersion,
          channel,
        });

        setGameDoc(gd);
        setGameVersionDoc(vs);
        setGameError(null);
        setGameLoading(false);
      } catch (error) {
        setGameError(error instanceof Error ? error.message : "Failed to load game");
        setGameLoading(false);
      }
    };

    loadGame();
  }, [game, version, majorVersion, channel]);

  return {
    game: gameDoc,
    gameVersion: gameVersion,
    loading: gameLoading,
    error: gameError,
  };
}
